export type PathWithInnerFieldName = string;

export interface StringInnerViewModel {
    [path: PathWithInnerFieldName]: string;
}

export interface ServerRawResponseRootItem {
    "@": StringInnerViewModel;
}

export type PathWithMultiplicityInstanceNumber = string;

export interface ServerRawResponseItem {
    [path: PathWithMultiplicityInstanceNumber]: StringInnerViewModel;
}

export const isServerRawResponseRootItem = (
    item: ServerRawResponseRootItem | ServerRawResponseItem
): item is ServerRawResponseRootItem => item["@"] != undefined;

export type ServerRawResponse = Readonly<[ServerRawResponseRootItem, ...ServerRawResponseItem[]]>;
